module.exports = __webpack_public_path__ + "static/img/A127.a837b9d7.jpg";